var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLungsound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14C23.2652 14 23.5196 14.1054 23.7071 14.2929C23.8946 14.4804 24 14.7348 24 15V20C24 20.3511 24.0924 20.6959 24.268 21C24.4435 21.304 24.696 21.5565 25 21.732V18.257C25 17.015 25.995 16 27.233 16C27.605 16 27.971 16.094 28.355 16.307L28.535 16.424C30.23 17.654 31.295 19.459 32.308 22.764C32.7573 24.2333 32.988 25.92 33 27.824C33.016 30.019 31.343 31.848 29.157 31.992L28.92 32C26.75 32 25 30.213 25 28.02V23.874C24.2776 23.6871 23.6219 23.302 23.107 22.762L23 22.644L22.893 22.762C22.3783 23.3018 21.723 23.687 21.001 23.874L21 28.02C21 30.213 19.25 32 17.081 32L16.813 31.99C14.658 31.848 12.986 30.019 13.002 27.825C13.014 25.9197 13.2447 24.233 13.694 22.765C14.705 19.458 15.77 17.653 17.516 16.39L17.704 16.273C18.0299 16.0935 18.396 15.9996 18.768 16C20.005 16 21 17.015 21 18.257L21.001 21.732C21.3049 21.5563 21.5571 21.3038 21.7325 20.9998C21.9078 20.6958 22.0001 20.351 22 20V15C22 14.7348 22.1054 14.4804 22.2929 14.2929C22.4804 14.1054 22.7348 14 23 14Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungsound);
export default __webpack_public_path__ + "static/media/lungsound.f42a5645fb33f885245188cbfa312dc0.svg";
export { ForwardRef as ReactComponent };